import socialMediaScraper from './socialMediaScraper';
import coreAccounts from './coreAccounts';
import { coreResults, coreSessions } from './core';

export const socialMediaScraperService = socialMediaScraper;
export const coreAccountsService = coreAccounts;
export const coreResultsService = coreResults;
export const coreSessionsService = coreSessions;
